



















































































































































































































































import InputText from '@/components/input/text.vue';
import ShowInfoItem from '@/components/show-info-item.vue';
import { strlen } from '@/utils/helper';
import {
    InvoiceContentType,
    InvoiceContentTypeMap,
    InvoiceType,
    InvoiceTypeMap,
    signRealizationWayMap,
} from '@/views/controllCenter/const';
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
    toRefs,
} from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import { GameContractModel } from './model';
import { state } from '@/utils/store';

export default defineComponent({
    props: {
        appId: {
            type: String,
            default: '',
        },
        invoice: {
            type: Object,
            default: {
                companyRegisteredAddress: '',
                companyMailingAddress: '',
                invoiceContentType: 1,
                invoiceType: 1,
            },
        },
    },
    components: {
        ShowInfoItem,
        InputText,
    },
    setup(props, context) {
        const model = useApolloModel(GameContractModel);
        const getStrlen = strlen;
        const state = reactive({
            companyRegisteredAddress: props.invoice.companyRegisteredAddress ?? '',
            companyMailingAddress: props.invoice.companyMailingAddress ?? '',
            invoiceContentType: props.invoice.invoiceContentType ?? 1,
            invoiceType: props.invoice.invoiceType ?? 1,
            gameProfitable: false,
            invoiceUpdateEnable: true,

            // 当前游戏是什么类型的
            realizationWay: 'iaa',

            // iap 类型发票信息
            iapInvoiceType: 1,
            iapInvoiceContentType: props.invoice.iapInvoiceContentType ?? 2,  // iap 只能是 信息服务费
            iapInvoiceUpdateEnable: true,

        });
        const canSubmit = computed(() => {
            if (
                state.companyRegisteredAddress?.length === 0 ||
                state.companyMailingAddress?.length === 0 ||
                Math.ceil(getStrlen(state.companyRegisteredAddress) / 2) >
                    100 ||
                Math.ceil(getStrlen(state.companyMailingAddress) / 2) > 100
            ) {
                return false;
            }
            return true;
        });
        onMounted(async () => {
            let contractNo = '';
            if (context.root.$route.query.renewContract === 'true') {
                contractNo = context.root.$route.query.contractNo as string;
                if (!contractNo || contractNo.length === 0) {
                    await model.contractDetailInfoMut({
                        appId: context.root.$route.params.appId,
                    });
                    contractNo =
                        model.contractDetailInfo.contractInfo?.contractNo;
                }
            }
            await model.contractSignInfoMut({
                appId: context.root.$route.params.appId,
                originalContractNo: contractNo ?? '',
            });
            for (const v in model.contractSignInfo) {
                // @ts-ignore
                state[v] = model.contractSignInfo[v];
            }
            if(state.realizationWay === 'iaa') {
                state.invoiceContentType = state.invoiceContentType || InvoiceContentType.PUBLISH;
                state.invoiceType = state.invoiceType || InvoiceType.SPECIAL6;
            }

            if(state.realizationWay === 'iap') {
                state.iapInvoiceContentType = state.iapInvoiceContentType || InvoiceContentType.SERVICE;
                state.iapInvoiceType = state.iapInvoiceType || InvoiceType.SPECIAL6;
            }

            if(state.realizationWay === 'iaap') {
                state.invoiceContentType = state.invoiceContentType || InvoiceContentType.PUBLISH;
                state.invoiceType = state.invoiceType || InvoiceType.SPECIAL6;
                state.iapInvoiceContentType = state.iapInvoiceContentType || InvoiceContentType.SERVICE;
                state.iapInvoiceType = state.iapInvoiceType || InvoiceType.SPECIAL6;
            }
        });
        return {
            model,
            canSubmit,
            ...toRefs(state),
            InvoiceContentType,
            InvoiceContentTypeMap,
            InvoiceType,
            InvoiceTypeMap,
            signRealizationWayMap
        };
    },
});
